import {defineMessages} from 'react-intl';

export const BANNER_LEGAL_DISCLAIMER = defineMessages({
  text: {
    id: 'Banner.legal.disclaimer',
    defaultMessage: '@@@ @@@',
    description: 'Banner legal disclaimer message'
  }
});
